import base from 'ky';
import CONFIG from './config';

const ky = base.extend({
	prefixUrl: CONFIG.API_ENDPOINT
});

export * from 'ky';
export default ky;
